<template>
  <div v-if="!widgetSettings.bookingId" :class="$style.base">
    <BaseButton
      fullWidth
      inverted
      @click="onBookAgainClick"
      v-test="'book-again'"
    >
      {{ $t('completed.book_again') }}
    </BaseButton>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue';
import widgetSettings from '@/widget-settings';

const onBookAgainClick = () => {
  window.parent.postMessage('szRefreshIframe', '*');
};
</script>

<style lang="scss" module>
.base {
  margin-top: $spacing;
}
</style>
